export default "__VITE_ASSET__DRg_fS4___"